export const useHapticFeedback = () => {
  const vibrate = (pattern: number | number[] = 50) => {
    if ('vibrate' in navigator) {
      navigator.vibrate(pattern);
    }
  };

  const success = () => vibrate([50, 30, 50]);
  const error = () => vibrate([100, 50, 100]);
  const light = () => vibrate(30);

  return { vibrate, success, error, light };
};
